export const videoClassesActionTypes = {
  SET_EMBED_VIEW_STATUS: 'SET_EMBED_VIEW_STATUS',
  SET_MODAL_VIEW_STATUS: 'SET_MODAL_VIEW_STATUS',
  REQUEST_LIVE_DATA: 'REQUEST_LIVE_DATA',
  SUCCESS_LIVE_DATA: 'SUCCESS_LIVE_DATA',
  FAILURE_LIVE_DATA: 'FAILURE_LIVE_DATA',
  SET_LIVE_DATA: 'SET_LIVE_DATA',
};
